import React from "react";
// Placeholder for future per-contract deep view
export default function ContractDetail() {
  return <div className="p-12">Contract detail view (coming soon).</div>;
}
